/**
 * Inline translations for the public help shell.
 *
 * Following the existing EZDocu pattern: the dashboard uses a typed
 * Translations system in `lib/i18n/`, but landing / legal / public pages
 * keep small inline maps so they don't pull the whole dashboard i18n
 * graph for half a dozen strings. Help pages match that pattern.
 */
export const HELP_LOCALES = ['en', 'es', 'pt', 'de', 'fr'] as const;
export type HelpLocale = (typeof HELP_LOCALES)[number];

export const HELP_LANGUAGES: { code: HelpLocale; flag: string; label: string }[] = [
  { code: 'en', flag: '🇺🇸', label: 'English' },
  { code: 'es', flag: '🇪🇸', label: 'Español' },
  { code: 'pt', flag: '🇧🇷', label: 'Português' },
  { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
  { code: 'fr', flag: '🇫🇷', label: 'Français' },
];

interface HelpStrings {
  backToHome: string;
  helpCenter: string;
  signIn: string;
  goToDashboard: string;
  language: string;
  related: string;
  lastUpdated: string;
  backToUpdates: string;
}

export const HELP_T: Record<HelpLocale, HelpStrings> = {
  en: {
    backToHome: 'Back to EZDocuAI',
    helpCenter: 'Help center',
    signIn: 'Sign in',
    goToDashboard: 'Open dashboard',
    language: 'Language',
    related: 'Related',
    lastUpdated: 'Last updated',
    backToUpdates: 'Back to Updates',
  },
  es: {
    backToHome: 'Volver a EZDocuAI',
    helpCenter: 'Centro de ayuda',
    signIn: 'Iniciar sesión',
    goToDashboard: 'Ir al panel',
    language: 'Idioma',
    related: 'Relacionados',
    lastUpdated: 'Última actualización',
    backToUpdates: 'Volver a Novedades',
  },
  pt: {
    backToHome: 'Voltar ao EZDocuAI',
    helpCenter: 'Central de ajuda',
    signIn: 'Entrar',
    goToDashboard: 'Abrir painel',
    language: 'Idioma',
    related: 'Relacionados',
    lastUpdated: 'Última atualização',
    backToUpdates: 'Voltar às Novidades',
  },
  de: {
    backToHome: 'Zurück zu EZDocuAI',
    helpCenter: 'Hilfe-Center',
    signIn: 'Anmelden',
    goToDashboard: 'Zum Dashboard',
    language: 'Sprache',
    related: 'Verwandt',
    lastUpdated: 'Zuletzt aktualisiert',
    backToUpdates: 'Zurück zu Neuigkeiten',
  },
  fr: {
    backToHome: 'Retour à EZDocuAI',
    helpCenter: "Centre d'aide",
    signIn: 'Se connecter',
    goToDashboard: 'Ouvrir le tableau de bord',
    language: 'Langue',
    related: 'Articles liés',
    lastUpdated: 'Dernière mise à jour',
    backToUpdates: 'Retour aux Nouveautés',
  },
};
